import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Router } from 'react-router-dom';

import { withAppContext } from '../../contexts/app';
import { withClinicalData } from '../../contexts/clinicalData';
import { withUser } from '../../contexts/user';

import { ConditionPhotographies } from '../../components/ConditionPhotographies';
import ConditionTreatments from '../../components/ConditionTreatments';

import Header from './shared/Header';
import Sidebar from './content/Sidebar';
import Navigator from './content/Navigator';
//import IntroSymptoms from './content/IntroSymptoms';
import ContentTopCTA from './content/ContentTopCTA';
import MobileTopCTA from './content/MobileTopCTA';

//import DoctorPhotoPlaceholder from 'images/ask/placeholders/condition-profile-photo.svg';

class Content extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: undefined,
      condition: undefined,
      reviewer: undefined,
      loading: true,
      error: undefined,
      html: undefined,
      menuItems: undefined,
      showSidebar: undefined,
      fromConditionResults: false
    };
  }

  componentDidMount() {
    this.loadContent(this.props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.loadContent(props);
  }

  loadContent(props) {
    if (!props.id) { return; }

    const { id, condition, severe, fromConditionResults } = props;
    const menuExists = condition && condition.menu ? true : false;
    const showSidebar = !this.state.fromConditionResults || menuExists;
    const reviewer = condition && condition.reviewer ? condition.reviewer : undefined;
    const menu = condition && condition.menu ? condition.menu : undefined;

    this.setState({
      id,
      condition,
      severe,
      reviewer,
      menu,
      showSidebar,
      fromConditionResults
    }, this.proxyContent);
  }

  render() {
    const { id, error, html, condition, reviewer, menu, fromConditionResults, showSidebar } = this.state;
    const { severe, user, history } = this.props;

    return (
      <React.Fragment>
        <div className="condition-content">
          <Header
            className="condition-content__header"
            title={condition ? condition.title : undefined}
            showBackButton={fromConditionResults && user.isLoggedIn}
            backButtonLabel={'Back to your results'}
            onBackButtonClick={() => { history.push('/results'); }}
            content={
              <div className="condition__reviewed">
                { reviewer &&
                  <React.Fragment>
                    <span className={`condition__reviewed__label ${!reviewer.name ? ' hidden-label' : ''}`}>
                      This page has been reviewed by:
                    </span>

                    <span className="condition__reviewed__user">
                      {/*<span className="condition__reviewed__user-photo"><img src={DoctorPhotoPlaceholder} title="Nancy Reid" /></span>*/}
                      <span className="condition__reviewed__user-name">{ reviewer.name }</span>
                      <span className="condition__reviewed__user-info">{ reviewer.description }</span>
                    </span>
                  </React.Fragment>
                }
              </div>
            }
          />

          <div className={`with-sidebar-layout ${ !showSidebar ? ' hide-sidebar' : ''}`}>

            { !fromConditionResults &&
              <MobileTopCTA />
            }

            { showSidebar &&
              <Sidebar
                conditionName={condition.title}
                severeCondition={severe}
                fromConditionResults={fromConditionResults}
                menuItems={menu}
                onItemClick={this.onItemClick.bind(this)}
              />
            }

            <div className="content">
              { !fromConditionResults &&
                <ContentTopCTA />
              }

              {/*
              <IntroSymptoms />
              */}

              { error &&
                <div className="condition__content">{error}</div>
              }

              <div
                ref={node => this.proxiedContentEl = node}
                className="condition__content"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
          </div>
        </div>

        { this.showResultsNavigator() &&
          <Navigator currentConditionId={id} />
        }
      </React.Fragment>
    );
  }

  onItemClick(id) {
    const element = document.getElementById(id);

    if (!element) { return; }

    const offset = 20;
    const elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    const targetPositon = elementPosition - offset;

    window.scrollTo({ top: targetPositon, behavior: 'smooth' });
  }

  proxyContent() {
    const { app } = this.props;

    let contentPath = `${app.healthPages.baseUrl}${app.healthPages.conditionPagesPath}/${this.state.id}`;

    // Append trailing slash if missing (or S3 will not serve the page correctly)
    if (contentPath.substr(-1) !== '/') { contentPath = contentPath + '/'; }

    fetch(contentPath, { mode: 'cors' })
      .then((response) => response.text())
      .then((html) => this.processHtml(html))
      .catch((/*error*/) => {
        this.setState({ error: 'There was a problem retrieving the condition information' /*error.message*/ });
      });
  }

  processHtml(html) {
    const { app } = this.props;
    const imageSrcRegExp = /<img .*?(?=src)src="(.[^"]*)"/gi;   // matches img tag src attr content
    let imageSources = [];
    let match = undefined;

    // Retrieve all img sources
    do {
      match = imageSrcRegExp.exec(html);
      if (match) { imageSources.push(match[1]); }
    } while (match);

    // Prepend the health pages domain to the sources, so that they're loaded straight from S3
    // instead of being proxied. (backend wouldn't take it too well either)
    imageSources.forEach((source) => {
      html = html.replace(source, `${app.healthPages.baseUrl}${source.slice(app.healthPages.basePath.length)}`);
    });

    this.setState({
      html: html,
      loading: false,
      error: undefined
    }, this.bootstrapReactComponents);
  }

  bootstrapReactComponents() {
    const { id, condition } = this.state;
    const { app, history } = this.props;

    const getElementIfTreatmentHeader = () => {
      const headerAfterTreatments = this.proxiedContentEl.querySelector('#treatments ~ h2');

      if (!headerAfterTreatments) return null;

      const treatmentsElement = document.createElement('div');
      headerAfterTreatments.insertAdjacentElement('beforebegin', treatmentsElement);
      return treatmentsElement;
    };

    const photosElement = this.proxiedContentEl.querySelector('#photos');
    const treatmentsElement = this.proxiedContentEl.querySelector('#sponsored-treatments') ||
                              getElementIfTreatmentHeader();

    // Condition sample photos
    if (photosElement && condition.sample_images) {
      const photos = condition.sample_images.slice().map((image) => {
        return {
          ...image,
          imageUrl: `${app.healthPages.baseUrl}/${image.image_url}`,
          thumbnailUrl: `${app.healthPages.baseUrl}/${image.thumbnail_url}`,
        };
      });

      ReactDOM.render(
        <Router history={history}>
          <ConditionPhotographies
            app={app}
            className="condition__photographies"
            title={'Photos'}
            linkToGallery={true}
            galleryLink={`${id}/photos`}
            galleryBackButtonLabel={`Back to ${condition.title}`}
            images={photos}
          />
        </Router>,
        photosElement
      );
    }

    if (treatmentsElement && condition.treatments) {
      ReactDOM.render(
        <ConditionTreatments treatments={condition.treatments} />,
        treatmentsElement
      );
    }
  }

  showResultsNavigator() {
    const { id, fromConditionResults } = this.state;
    const { user, clinicalData } = this.props;

    return (
      id !== undefined
      && user.isLoggedIn
      && fromConditionResults === true
      && clinicalData.inference.predictions
      && this.allConditionsHaveAHealthPage()
    );
  }

  allConditionsHaveAHealthPage() {
    const { clinicalData } = this.props;
    const predictions = clinicalData.inference.predictions;
    const conditions = predictions.map(p => p.condition);
    const conditionsWithHealthPage = conditions.filter(c => c.healthPage !== null);

    return (conditionsWithHealthPage.length === predictions.length);
  }
}

Content.defaultProps = {
  severe: false,
  fromConditionResults: false
};

Content.propTypes = {
  id: PropTypes.string,
  condition: PropTypes.object,
  severe: PropTypes.bool,
  fromConditionResults: PropTypes.bool,

  app: PropTypes.object.isRequired,
  clinicalData: PropTypes.object,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export { Content };
export default withAppContext(withClinicalData(withUser(Content)));